__turbopack_context__.v({
  "btnLink": "styles-module-scss-module__s0SjgW__btnLink",
  "caption": "styles-module-scss-module__s0SjgW__caption",
  "content": "styles-module-scss-module__s0SjgW__content",
  "root": "styles-module-scss-module__s0SjgW__root",
  "title": "styles-module-scss-module__s0SjgW__title",
});
